import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Constants from 'expo-constants';
import { observer } from 'mobx-react-lite';
import React from 'react';

import OrderDetailsStep from './OrderDetailsStep';

const OrderDetailsWrapper = () => {
  const stripePromise = loadStripe(Constants.manifest?.extra!.stripeKey);
  return (
    <Elements stripe={stripePromise}>
      <OrderDetailsStep />
    </Elements>
  );
};

export default observer(OrderDetailsWrapper);
